// src/services/authService.js
import API from './Api';

// Register
export const registerUser = (userData) =>
  API.post('/auth/register', userData).then(res => res.data);

// Login - does NOT store tokens directly anymore
export const loginUser = async (userData) => {
  try{
  const { latitude, longitude, ...body } = userData;
  const headers = {};
  if (latitude) headers['X-Latitude'] = latitude;
  if (longitude) headers['X-Longitude'] = longitude;
  const res = await API.post('/auth/login', body, { headers });
  console.log("Pre ready to login");
  return res.data;
  }catch(err){
    throw err;
  }
};


export const getEmployeeAccess = async (employeeId) => {
  const res = await API.get(`/admin/employee-access/${employeeId}`);
  return res.data.data; // This returns EmployeeMenuAccessResponseDTO
};

// Request password reset
export const requestPasswordReset = (userData) =>
  API.post('/auth/forgot-password', userData).then(res => res.data);

// Reset password
export const resetPassword = (userData) =>
  API.post('/auth/reset-password', userData).then(res => res.data);

// Force change password on first login
export const forceChangePassword = (data) =>
  API.post('/auth/force-change-password', data).then(res => res.data);

// Refresh Access Token
export const refreshAccessToken = async () => {
  const res = await API.post('/auth/refresh-token');
  return res.data.accessToken;
};

// In src/services/authService.js
export const logoutUser = async (refreshToken) => {
  return API.post('/auth/logout', { refreshToken });
};


// const API_URL = 'http://localhost:8081/api/auth';

// export const registerUser = async (userData) => {
//   const response = await axios.post(`${API_URL}/register`, userData);
//   return response.data;
// };

// export const loginUser = async (userData) => {
//   const response = await axios.post(`${API_URL}/login`, userData);
//   return response.data;
// };

// export const requestPasswordReset = async (userData)=>{
//   const response =await axios.post(`${API_URL}/forgot-password`, userData);
//   return response.data;
// }

// export const resetPassword = async (userData)=>{
//   const response= await axios.post(`${API_URL}/reset-password`, userData);
//   return response.data;
// }